<main class="c-main wow-consulta">

    <div class="container-fluid">

        <div class="row">

            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>

        </div>

        <div class="mat-elevation-z8">

            <mat-card>

                <div class="wow-consulta__header">

                    <div class="wow-consulta__header-icon"><mat-icon>attach_money</mat-icon></div>

                    <mat-card-title>Contas à Receber</mat-card-title>

                </div>



                <app-wow-consulta-filtros

                    [tipoFiltros]="tipoFiltros"

                    [(tipoFiltro)]="tipoFiltro"

                    [(parametro)]="parametro"

                    [showParametro]="tipoFiltro === 'ID' || tipoFiltro === 'Pagador'"

                    [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"

                    [labelParametro]="tipoFiltro === 'Pagador' ? 'Pagador' : ''"

                    [layoutInline]="true"

                    (tipoFiltroChange)="onFiltroChange()"

                    (consultar)="consultar()"

                    (novo)="novo()">

                    <div class="wow-consulta__campo">
                        <mat-form-field appearance="fill" class="full-width">
                            <mat-label>Situação</mat-label>
                            <mat-select [(ngModel)]="filtroSituacao" (selectionChange)="onFiltroChange()">
                                <mat-option [value]="null">Todas</mat-option>
                                <mat-option *ngFor="let s of situacoesFiltro" [value]="s.valor">{{ s.label }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="tipoFiltro !== 'Pagador' && tipoFiltro !== 'ID'">
                        <div class="wow-consulta__campo">
                            <mat-form-field appearance="fill" class="full-width">
                                <mat-label>Data início</mat-label>
                                <input matInput [matDatepicker]="pickerInicio" [(ngModel)]="dataInicioFiltro">
                                <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                                <mat-datepicker #pickerInicio></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="wow-consulta__campo">
                            <mat-form-field appearance="fill" class="full-width">
                                <mat-label>Data fim</mat-label>
                                <input matInput [matDatepicker]="pickerFim" [(ngModel)]="dataFimFiltro">
                                <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                <mat-datepicker #pickerFim></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </ng-container>

                </app-wow-consulta-filtros>



                <div class="wow-consulta__empty" *ngIf="!consultaRealizada">

                    Informe os filtros e clique em <strong>Consultar</strong>.

                </div>



                <ng-container *ngIf="consultaRealizada">

                    <table mat-table [dataSource]="contasReceber" class="full-width">

                        <ng-container matColumnDef="id">

                            <th mat-header-cell *matHeaderCellDef>ID</th>

                            <td mat-cell *matCellDef="let r">{{ r.id }}</td>

                        </ng-container>

                        <ng-container matColumnDef="tipoPagador">

                            <th mat-header-cell *matHeaderCellDef>Tipo</th>

                            <td mat-cell *matCellDef="let r">{{ r.tipoPagador || r.pagador }}</td>

                        </ng-container>

                        <ng-container matColumnDef="pagadorDescricao">

                            <th mat-header-cell *matHeaderCellDef>Pagador</th>

                            <td mat-cell *matCellDef="let r">{{ r.pagadorDescricao }}</td>

                        </ng-container>

                        <ng-container matColumnDef="formaCobranca">

                            <th mat-header-cell *matHeaderCellDef>Cobrança</th>

                            <td mat-cell *matCellDef="let r">{{ r.formaCobranca }}</td>

                        </ng-container>

                        <ng-container matColumnDef="parcela">

                            <th mat-header-cell *matHeaderCellDef>Parcela</th>

                            <td mat-cell *matCellDef="let r">{{ r.parcela }}</td>

                        </ng-container>

                        <ng-container matColumnDef="total">

                            <th mat-header-cell *matHeaderCellDef>Valor</th>

                            <td mat-cell *matCellDef="let r">{{ r.total | currency:'BRL' }}</td>

                        </ng-container>

                        <ng-container matColumnDef="atualizado">

                            <th mat-header-cell *matHeaderCellDef>Atualizado</th>

                            <td mat-cell *matCellDef="let r">
                                <ng-container *ngIf="r.diasAtraso > 0 && r.totalAtualizado > r.total; else semEncargo">
                                    <span class="cr-valor-atualizado" matTooltip="Vencida há {{ r.diasAtraso }} dia(s) — juros/multa estimados">
                                        {{ r.totalAtualizado | currency:'BRL' }}
                                    </span>
                                </ng-container>
                                <ng-template #semEncargo>—</ng-template>
                            </td>

                        </ng-container>

                        <ng-container matColumnDef="dtVencimento">

                            <th mat-header-cell *matHeaderCellDef>Vencimento</th>

                            <td mat-cell *matCellDef="let r">{{ r.dtVencimento }}</td>

                        </ng-container>

                        <ng-container matColumnDef="dtPagamento">

                            <th mat-header-cell *matHeaderCellDef>Recebimento</th>

                            <td mat-cell *matCellDef="let r">{{ r.dtRecebimento || r.dtPagamento }}</td>

                        </ng-container>

                        <ng-container matColumnDef="situacao">

                            <th mat-header-cell *matHeaderCellDef>Situação</th>

                            <td mat-cell *matCellDef="let r">{{ r.situacaoDescricao || r.situacao }}</td>

                        </ng-container>

                        <ng-container matColumnDef="excluir">

                            <th mat-header-cell *matHeaderCellDef></th>

                            <td mat-cell *matCellDef="let r" (click)="$event.stopPropagation()">

                                <button (click)="openDialog(r.id)" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>

                            </td>

                        </ng-container>

                        <ng-container matColumnDef="editar">

                            <th mat-header-cell *matHeaderCellDef></th>

                            <td mat-cell *matCellDef="let r" (click)="$event.stopPropagation()">

                                <button (click)="editar(r.id)" mat-icon-button color="accent"><mat-icon>edit</mat-icon></button>

                            </td>

                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>

                        <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
                          (click)="editar(row.id)"></tr>

                    </table>

                    <mat-paginator [length]="totalElementos" [pageSize]="tamanho" [pageSizeOptions]="pageSizeOptions"

                        (page)="paginar($event)"></mat-paginator>

                </ng-container>

            </mat-card>

        </div>

    </div>

</main>

